import { SaveChartProps } from 'src/Libs/system-data-handler/types'
import { getChartsEditingSettings, useUpdateEditedChartSettings } from 'src/Libs/chart-kit'
import { useUserSettings } from 'src/Hooks'
import useDefaultAndCustomCharts from './use-default-and-custom-charts'
import { useTypedSelector } from 'src/State/RootReducer'

interface ReturnType {
  handleSaveCharts: (props: SaveChartProps) => void
}

/**
 * this hook provides system chart related functionalities such as saving chart settings
 */
const useSystemCharts = ({ installationId, storageId }: { installationId: number; storageId?: string }): ReturnType => {
  const { userSettings } = useUserSettings()
  const userId = useTypedSelector(state => state.auth.userId)

  const { defaultAndCustomCharts } = useDefaultAndCustomCharts(userSettings)

  const chartSettings = getChartsEditingSettings(userSettings)
  const { saveCharts } = useUpdateEditedChartSettings(defaultAndCustomCharts)

  const handleSaveCharts = (props: SaveChartProps): void => {
    saveCharts({
      chartId: props.chartSettings.id,
      chartSettings: props.chartSettings,
      chartSettingsList: chartSettings,
      userId,
      installationId,
      storageSerialNumber: storageId,
      isInitial: props.customLayout.isInitial,
    })
  }

  return { handleSaveCharts }
}

export default useSystemCharts
